import { User } from '@progress/kendo-react-conversational-ui';
import userAvatar from '../assets/chat-user.svg';

export const DEFAULT_USER: User = {
    id: 1,
    name: 'Demo User',
    avatarUrl: userAvatar
};

export const BOT_USER: User = {
    id: 0,
    name: 'Research Assistant',
    avatarUrl: 'https://demos.telerik.com/kendo-ui/content/web/Customers/BERGS.jpg'
};
